export default __webpack_public_path__ + "static/media/amex.d02c5889.svg";